<script setup>
import { computed, inject } from 'vue';
import { flowThreadContextKey } from './flowThreadContext';
import NodeBadge from '../ui/NodeBadge.vue';
import NodeInlineField from '../ui/NodeInlineField.vue';

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const context = inject(flowThreadContextKey);
const hasTitleValue = computed(() =>
  Boolean(props.node.config?.title?.trim?.())
);
</script>

<template>
  <div class="bg-white px-3 py-2.5">
    <NodeBadge
      :label="
        node.type === 'button'
          ? context.uiCopy.buttonPath
          : context.uiCopy.listPath
      "
      variant="successSoft"
    />
    <NodeInlineField
      v-if="isSelected"
      :model-value="node.config?.title || ''"
      :placeholder="node.label"
      variant="plain"
      @update:model-value="context.updateNode({ title: $event })"
    />
    <div
      v-else
      class="mt-2 text-[12px] font-medium"
      :class="hasTitleValue ? 'text-n-slate-12' : 'text-n-slate-9'"
    >
      {{ node.config?.title || node.label }}
    </div>
    <div
      v-if="node.config?.description"
      class="mt-0.5 text-[11px] leading-4 text-n-slate-11"
    >
      {{ node.config.description }}
    </div>
  </div>
</template>
